import { useContext, useEffect } from "react";
import { TabBarContext } from "@/components/nav/TabBarContext";

/**
 * A screen declaring that the mobile tab bar does not belong on it.
 *
 * **By state, never by scroll** (SPEC_NAVEGACION_MOVIL, "Cuándo se oculta la
 * barra"). A bar that hides on scroll is a bar you cannot find when you want
 * it; this one is absent only where the screen owns the bottom of the viewport
 * or has its own way out — Dany's full-screen conversation and a live voice
 * call are the two Jorge fixed for T12.
 *
 * The screen calls it on mount and the bar comes back on unmount, with the
 * tab that was active before still active: the bar renders from the route, so
 * there is no "previous tab" to store — the route already is it.
 *
 * `active` lets a screen hide the bar for part of its life (a voice call inside
 * the thread) without a second component.
 */
export function useHideTabBar(active = true) {
  const ctx = useContext(TabBarContext);
  const request = ctx?.requestHide;
  useEffect(() => {
    if (!request || !active) return undefined;
    return request();
  }, [request, active]);
}

export default useHideTabBar;
